function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_22",
  "data-name": "Group 22",
  transform: "translate(-354.325 -137.323)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_67",
  "data-name": "Rectangle 67",
  width: 40.543,
  height: 12.355,
  rx: 3,
  transform: "translate(354.325 137.323)",
  fill: "#f9b233"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(358.442 143.293)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M379.6,188.261l-16-15.534V150.774h32.31v21.953L379.6,188.261",
  transform: "translate(-363.601 -150.774)",
  fill: "#63b5f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M391.836,188.261l-6.235-6.054V150.774h12.782v31.273l-6.546,6.214",
  transform: "translate(-375.836 -150.774)",
  fill: "#3d9ae2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_21",
  "data-name": "Group 21",
  transform: "translate(356.178 180.669)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_34",
  "data-name": "Path 34",
  transform: "translate(-358.5 -234.988)",
  fill: "#fc0",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 376.918701171875 267.9406433105469 C 372.663330078125 267.9406433105469 368.6672973632812 266.3478698730469 365.6667175292969 263.4557189941406 C 362.691650390625 260.5881958007812 361.0531921386719 256.7827758789062 361.0531921386719 252.740478515625 C 361.0531921386719 248.6984558105469 362.6916198730469 244.8932800292969 365.6666564941406 242.0258941650391 C 368.667236328125 239.1338958740234 372.6632995605469 237.5412139892578 376.918701171875 237.5412139892578 C 381.1741027832031 237.5412139892578 385.1701354980469 239.1338958740234 388.1707153320312 242.0258941650391 C 391.1457214355469 244.8932800292969 392.7841491699219 248.6984558105469 392.7841491699219 252.740478515625 C 392.7841491699219 256.7827758789062 391.1457214355469 260.5881958007812 388.170654296875 263.4557495117188 C 385.1701049804688 266.3478698730469 381.174072265625 267.9406433105469 376.918701171875 267.9406433105469 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 376.918701171875 240.0943908691406 C 369.5782775878906 240.0943908691406 363.6064147949219 245.7674255371094 363.6064147949219 252.740478515625 C 363.6064147949219 259.7140502929688 369.5782775878906 265.387451171875 376.918701171875 265.387451171875 C 384.2590942382812 265.387451171875 390.2309265136719 259.7140502929688 390.2309265136719 252.740478515625 C 390.2309265136719 245.7674255371094 384.2590942382812 240.0943908691406 376.918701171875 240.0943908691406 M 376.918701171875 234.9880065917969 C 387.0906982421875 234.9880065917969 395.3373413085938 242.9360046386719 395.3373413085938 252.740478515625 C 395.3373413085938 262.5454711914062 387.0906982421875 270.4938354492188 376.918701171875 270.4938354492188 C 366.7467041015625 270.4938354492188 358.5 262.5454711914062 358.5 252.740478515625 C 358.5 242.9360046386719 366.7467041015625 234.9880065917969 376.918701171875 234.9880065917969 Z",
  stroke: "none",
  fill: "#fdc00f"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M381.961,242.629l1.77,1.555,2.123-1.02,1.284,1.975,2.32-.409.7,2.248,2.345.232.071,2.354,2.195.856-.567,2.286,1.882,1.416-1.162,2.048,1.43,1.872-1.672,1.659.872,2.188-2.057,1.146.25,2.342-2.291.549-.391,2.323-2.354-.09-1,2.132-2.243-.722-1.541,1.782-1.965-1.3-1.964,1.3-1.542-1.782-2.243.722-1-2.132-2.353.09-.391-2.323-2.292-.549.25-2.342-2.057-1.146.872-2.188-1.672-1.659L369,256.171l-1.162-2.048,1.882-1.416-.567-2.286,2.195-.856.072-2.354,2.344-.232.7-2.248,2.32.409,1.285-1.975,2.123,1.02Z",
  transform: "translate(-363.543 -239.238)",
  fill: "#f9b233"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M397.015,260.75a11.8,11.8,0,1,1-11.788-11.361A11.581,11.581,0,0,1,397.015,260.75Z",
  transform: "translate(-366.809 -242.998)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Path_37",
  "data-name": "Path 37",
  transform: "translate(-368.73 -244.848)",
  fill: "#ffd633",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M 387.1484375 270.9856872558594 C 382.3206787109375 270.9856872558594 378.3930053710938 267.2242736816406 378.3930053710938 262.600830078125 C 378.3930053710938 257.9774169921875 382.3206787109375 254.2160034179688 387.1484375 254.2160034179688 C 391.9761962890625 254.2160034179688 395.9038696289062 257.9774169921875 395.9038696289062 262.600830078125 C 395.9038696289062 267.2242736816406 391.9761962890625 270.9856872558594 387.1484375 270.9856872558594 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 387.1484375 255.7160034179688 C 383.1477661132812 255.7160034179688 379.8930053710938 258.8045349121094 379.8930053710938 262.600830078125 C 379.8930053710938 266.3971557617188 383.1477661132812 269.4856872558594 387.1484375 269.4856872558594 C 391.1491088867188 269.4856872558594 394.4038696289062 266.3971557617188 394.4038696289062 262.600830078125 C 394.4038696289062 258.8045349121094 391.1491088867188 255.7160034179688 387.1484375 255.7160034179688 M 387.1484375 252.7160034179688 C 392.8125 252.7160034179688 397.4038696289062 257.1417846679688 397.4038696289062 262.600830078125 C 397.4038696289062 268.0598449707031 392.8125 272.4856872558594 387.1484375 272.4856872558594 C 381.484375 272.4856872558594 376.8930053710938 268.0598449707031 376.8930053710938 262.600830078125 C 376.8930053710938 257.1417846679688 381.484375 252.7160034179688 387.1484375 252.7160034179688 Z",
  stroke: "none",
  fill: "#fdc00f"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_68",
  "data-name": "Rectangle 68",
  width: 33.731,
  height: 2.203,
  transform: "translate(357.731 141.298)",
  fill: "#f9b233"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  "data-name": "Path 38",
  d: "M399.6,233.033a1.419,1.419,0,0,1-1.5,1.315H398a1.42,1.42,0,0,1-1.505-1.315v-6.689A1.42,1.42,0,0,1,398,225.028h.1a1.42,1.42,0,0,1,1.5,1.316Z",
  transform: "translate(-23.451 -48.779)",
  fill: "#f9b233"
}));

var SvgRank2 = function SvgRank2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40.543,
    height: 78.852,
    viewBox: "0 0 40.543 78.852",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRank2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rank-2.070247a1.svg";
export { ForwardRef as ReactComponent };